import { createAction, props } from '@ngrx/store';
import { ChangePasswordModel } from 'src/app/models/recovery/change-password.model';
import { User } from 'src/app/models/vet-users/user.model';


export const ChangePassword = createAction('[Recovery] Change Password', props<{ changeRequest: ChangePasswordModel}>());
export const ChangePasswordSuccess = createAction(
  '[Recovery] Change Password Success',
  props<{ response: boolean }>()
);
export const ChangePasswordFailure = createAction(
  '[Recovery] Change Password Failure',
  props<{ err: any }>()
);

export const GetUserByRecoveryEncryptedId = createAction('[Recovery] User Info',
  props<{ encryptedId: string }>());
export const GetUserByRecoveryEncryptedIdSuccess = createAction(
  '[Recovery]  User Info Success',
  props<{ user: User }>()
);
export const GetUserByRecoveryEncryptedIdFailure = createAction(
  '[Recovery] User Info Failure',
  props<{ err: any }>()
);

